const filter=[

{
   id:"1",
   title:"All" 
}, 
{
   id:"2",
   title:"Web Development" 
}, 
{
   id:"3",
   title:"DSA" 
}, 
{
   id:"5",
   title:"C++" 
}
];

export const skills=[
{ 
  id:"1", 
  heading:"html",
  percentage:"78",
  width:"3/4"
},
{
   id:"2", 
  heading:"Css",
  percentage:"82",
  width:"4/5"
},
{
   id:"3", 
  heading:"Javascript",
  percentage:"75",
  width:"3/4"
},
{
   id:"4", 
  heading:"Tailwind",
  percentage:"82",
  width:"4/5"
},
{
   id:"5", 
  heading:"React",
  percentage:"75",
  width:"3/4"
},
{
   id:"6", 
  heading:"C++",
  percentage:"92",
  width:"11/12"
},
{
   id:"7", 
  heading:"Dsa",
  percentage:"72",
  width:"3/4"
},

];

export default filter;
